import { FileText, Search, Shield, LayoutDashboard } from 'lucide-react';

const services = [
  {
    icon: FileText,
    title: 'OSINT Reporting On Demand',
    description: 'Are emerging risks impacting your operations before you even know they exist? Do you need to be aware of events so you can brief your stakeholders and implement contingencies? Stay ahead of domestic and international security threats, crime, and disruptions with decision-ready, near real-time tactical intelligence delivered directly to your inbox when you need it.',
    color: 'blue',
  },
  {
    icon: Search,
    title: 'Operational & Strategic OSINT',
    description: 'Are you responding to incidents — or anticipating what comes next? Move beyond isolated events with intelligence that connects patterns, identifies emerging risks, and informs both immediate operational decisions and longer-term strategy. Gain forward-looking insight into shifting threats and the factors shaping your operating environment.',
    color: 'orange',
  },
  {
    icon: Shield,
    title: 'Threat Analysis',
    description: 'Understand what matters, what is changing, and what it means for your operations. Our threat analysis distils complex, multi-source information into clear assessments of intent, capability, and likelihood—identifying emerging risks, escalation indicators, and potential impacts. The result is focused, decision-ready insight to support timely action, resource allocation, and risk mitigation.',
    color: 'blue',
  },
  {
    icon: LayoutDashboard,
    title: 'Custom Dashboards',
    description: 'Tailored intelligence dashboards that consolidate your data sources, track key metrics, and deliver insights where and when you need them. Built for clarity and speed, these dashboards transform fragmented information into a single, live intelligence picture.',
    color: 'orange',
  },
];

const ServiceCard = ({ icon: Icon, title, description, color, index }) => {
  const borderColor = color === 'blue' ? 'border-t-helix-blue' : 'border-t-helix-orange';
  const bgColor = color === 'blue' ? 'bg-blue-50 text-helix-blue' : 'bg-orange-50 text-helix-orange';

  return (
    <div
      data-testid={`service-card-${index}`}
      className={`bg-white rounded-xl shadow-lg p-8 border-t-4 ${borderColor} h-full transition-transform duration-300 hover:-translate-y-1`}
    >
      <div className={`w-12 h-12 rounded-lg flex items-center justify-center mb-6 ${bgColor}`}>
        <Icon className="w-6 h-6" />
      </div>
      <h3 className="text-xl font-bold text-gray-900 mb-4">{title}</h3>
      <p className="text-gray-600 leading-relaxed">{description}</p>
    </div>
  );
};

const Services = () => {
  return (
    <section data-testid="services-section" id="services" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-xs tracking-[0.2em] uppercase text-gray-500 font-medium mb-4 block">
            Our Expertise
          </span>
          <h2 data-testid="services-title" className="text-3xl sm:text-4xl font-bold text-gray-900">
            Comprehensive OSINT and Security
            <br />
            Solutions
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {services.map((service, index) => (
            <ServiceCard key={index} {...service} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
